import styled from 'styled-components'

export const Image = styled.img`
  max-width: 120px;
  margin-bottom: 24px;
`

